import useAuthRedirect from "hooks/useAuthRedirect"
import useCurrent from "lib/use-current"
import { useStateMachine } from "little-state-machine"
import { updateChatStore } from "stores/chat-store"

export interface ExhibitorChat {
  isEnabled: boolean
  open: (institutionId: string) => void
}

export const useExhibitorChat = (): ExhibitorChat => {
  const current = useCurrent()
  const authRedirect = useAuthRedirect()

  const { actions } = useStateMachine({ updateChatStore })
  const updateChatState = actions.updateChatStore

  const open = (institutionId: string) =>
    authRedirect(() => {
      updateChatState({
        institutionId,
      })
    })

  const isEnabled = current?.config?.has_exhibitor_chat ?? false

  return {
    isEnabled,
    open,
  }
}
